import { useContext, useEffect, useState } from 'react';
import AppContext from 'contexts/AppContext';
import { getCommercesWithPagination } from 'services/commerceServices';
import { getVenues } from 'services/venuesServices';
import StorageType from 'types/enums/StorageType';
import UserRoleType from 'types/enums/UserRoleType';
import Commerce from 'types/models/Commerce';
import Venue from 'types/models/Venue';
import { useTranslation } from 'react-i18next';

type SetupEntity = Commerce | Venue | null;

function useSetupInitialState(): SetupEntity {
  const { authData } = useContext(AppContext);
  const [entity, setEntity] = useState<SetupEntity>(null);
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!authData) {
      i18n.changeLanguage('es');
      setEntity(null);
      return;
    }

    const role = authData.user.role;

    const setup = async () => {
      try {
        if (role === UserRoleType.CommerceEditor) {
          const stored = localStorage.getItem(StorageType.CurrentCommerce);
          if (stored) {
            setEntity(JSON.parse(stored));
            return;
          }
          const paginationData = await getCommercesWithPagination();
          if (paginationData?.data?.length) {
            const commerce = paginationData.data[0];
            setEntity(commerce);
            localStorage.setItem(StorageType.CurrentCommerce, JSON.stringify(commerce));
          }
        }

        if (role === UserRoleType.VenueEditor) {
          const stored = localStorage.getItem(StorageType.CurrentVenue);
          if (stored) {
            setEntity(JSON.parse(stored));
            return;
          }
          const paginationData = await getVenues();
          if (paginationData?.data?.length) {
            const venue = paginationData.data[0];
            i18n.changeLanguage(venue.language);

            setEntity(venue);
            localStorage.setItem(StorageType.CurrentVenue, JSON.stringify(venue));
          }
        }
      } catch (error) {
        console.warn('Error initializing state:', error);
      }
    };

    setup();
  }, [authData]);

  return entity;
}

export default useSetupInitialState;
